import { h } from 'vue'
import { toast } from 'vue-sonner'
import { z } from 'zod'

/**
 * Load .env file and validate it against the schema
 * Has this file, it will be loaded automatically by vite and we will be have environment variables available type
 * If EnvSchema Object has Key but not in .env file, it will be have a error in page
 */

const EnvSchema = z.object({
  VITE_SERVER_API_TIMEOUT: z.coerce.number().default(5000),
  VITE_SERVER_API_PLATFORM: z.string().url().default('https://platform-api.test.attribuly.com'),
  VITE_ALLY_CLAW_WS_PROXY_BASE_URL: z.string().url().optional(),
  VITE_SERVER_API_SHOPIFY: z.string().url().default('https://shpf-api.test.attribuly.com'),
  VITE_SERVER_API_DATA: z.string().url().default('https://data-api.test.attribuly.com'),
  VITE_SERVER_API_MESSAGE: z.string().url().default('https://message-api.test.attribuly.com'),
  VITE_SERVER_API_LEAD: z.string().url().default('https://lead-api.test.attribuly.com'),
  VITE_SERVER_API_AD_NEXT: z.string().url().default('https://ad-api.test.attribuly.com'),

  VITE_GOOGLE_CLIENT_ID: z.string().default(''),
  VITE_GOOGLE_SIGNIN_THEME: z.string().default('outline'),
  VITE_GOOGLE_SIGNIN_SIZE: z.string().default('large'),
  VITE_GOOGLE_SIGNIN_WIDTH: z.string().default('340'),
  VITE_GOOGLE_SIGNIN_TEXT: z.string().default('continue_with'),
  VITE_GOOGLE_SIGNIN_LOCALE: z.string().default('zh_CN'),
  VITE_GOOGLE_SIGNIN_LOGO_ALIGNMENT: z.string().default('center'),

  VITE_PUBLIC_V2_PATH: z.string().default('/apple/'),
  VITE_SUBSCRIPTION_PAGE_URL: z.string().url().optional(),
  VITE_SHOPIFY_THEME_APP_EMBED_ID: z.string().optional(),
  VITE_AMPLITUDE_API_KEY: z.string().default(''),
  VITE_AI_ASSISTANT_ALLOWED_TEAMS: z.string().default(''),
  VITE_POST_PURCHASE_SURVEY_TEAM_IDS: z.string().default(''),
  VITE_CANNY_APP_ID: z.string().default(''),
  VITE_SERVER_API_INTENT_TAG: z.string().url().default('http://localhost:8080'),
})

export type env = z.infer<typeof EnvSchema>

const parsed = EnvSchema.safeParse(import.meta.env)

if (!parsed.success) {
  console.error('❌ Invalid env')
  console.error(parsed.error.flatten().fieldErrors)
  toast.error(`Env error: you should check your .env file`, {
    description: h('pre', { class: 'mt-2 w-[340px] rounded-md bg-slate-950 p-4' }, h('code', { class: 'text-white' }, JSON.stringify(parsed.error, null, 2))),
  })
}

export default (parsed.success ? parsed.data : EnvSchema.parse({}))
